import { render, staticRenderFns } from "./AffiliateBookings.vue?vue&type=template&id=38aae8e6&"
import script from "./AffiliateBookings.vue?vue&type=script&lang=js&"
export * from "./AffiliateBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports